import { ReactNode } from "react";
import cancel from "../../assets/x-mark.png";

interface ModalProps {
  children: ReactNode;
  header: string;
  openModal: boolean;
  setOpenModal: () => void;
}

export default function Modal({
  children,
  header,
  openModal,
  setOpenModal,
}: ModalProps) {
  return (
    <div>
      {openModal && (
        <div className="h-screen w-full flex items-center fixed top-0 left-0 justify-center bg-[#0A0909]/10 bg-opacity-40">
          <div className="bg-white w-full max-lg:mx-6 lg:w-1/3 h-auto rounded-lg pb-6 relative min-h-[500px]">
            <div className="border-b p-5 border-border flex items-center justify-between">
              <h1 className="font-semibold text-xl">{header}</h1>
              <img
                onClick={() => setOpenModal()}
                src={cancel}
                alt=""
                className="w-6 h-6 hover:cursor-pointer"
              />
            </div>
            <div className="px-6 py-5">{children}</div>
          </div>
        </div>
      )}
    </div>
  );
}
